export const useVisualConfigStore = defineStore('visualConfig', () => {
  const theme = ref('default')
  const sidebarVisible = ref(true)
  const unfoldableState = ref(false)
  const showBackDrop = ref(true)

  if (localStorage.getItem('theme')) {
    theme.value = JSON.parse(localStorage.getItem('theme'))
  }

  function toggleTheme(themeInput) {
    theme.value = themeInput
    localStorage.setItem('theme', JSON.stringify(theme.value))
  }

  function toggleSidebar() {
    sidebarVisible.value = !sidebarVisible.value
  }

  function sidebarVisibleDependsOnScreenWidth() {
    if (screen.width <= 768) {
      sidebarVisible.value = false
    }
  }

  sidebarVisibleDependsOnScreenWidth()
  window.addEventListener('resize', () => {
    sidebarVisibleDependsOnScreenWidth()
  })

  return { theme, toggleTheme, toggleSidebar, sidebarVisible, unfoldableState, showBackDrop }
})
